exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#carousel-container #image-slider[data-v-64b3732e]{display:inline}.packages-list[data-v-64b3732e]{-webkit-transform:translateY(10px) 1s ease;transform:translateY(10px) 1s ease;-webkit-transform:translateX(10px) 1s ease;transform:translateX(10px) 1s ease;-webkit-transition:-webkit-transform 1s;transition:-webkit-transform 1s;transition:transform 1s;transition:transform 1s,-webkit-transform 1s}.show-on-hover[data-v-64b3732e]{opacity:0;-webkit-transition:opacity .5s ease-in;transition:opacity .5s ease-in}.on-hover:hover .show-on-hover[data-v-64b3732e]{opacity:1}.place-bottom[data-v-64b3732e]{position:absolute;bottom:20px;right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64b3732e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/packageTuple.vue
// module id = v/0o
// module chunks = 1